import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { FiEdit, FiPlus, FiSearch, FiTrash2, FiUser } from "react-icons/fi";

import { TableContextProvider } from "./../../store/table-context";
import { confirm, modalSuccess } from "../../services/notifications";
import { actions, getToken, hasPermission } from "../../services/security";

import Card from "./../../Components/ui/card";
import Header from "../../Components/ui/header";
import Filters from "../../Components/ui/filters";
import Table from "../../Components/ui/table";
import Estado from "../../Components/estado/Estado";
import { BASEURL } from "../../services/url";
import http from "../../services/http";

const UsuariosListPage = () => {
  let navigate = useNavigate();

  const title = "Usuarios";
  const icon = <FiUser />;
  const breadcrumb = [{ title: "Usuarios", url: "/usuarios" }];
  const [filters, setFilters] = useState([
    {
      type: "input",
      label: "Nombre",
      name: "nombre",
    },
    {
      type: "input",
      label: "Email",
      name: "email",
    },
  ]);

  const columns = [
    { title: "Usuario", property: "nombreUsuario", sortable: true },
    { title: "Nombre", property: "nombre", sortable: true },
    { title: "Email", property: "email", sortable: true },
    { title: "Apellido", property: "apellido", sortable: true },
  ];

  const menuSearch = [
    {
      key: "3",
      icon: <FiSearch />,
      label: "Ver",
    }
  ]

  const menuEdit = [
    {
      key: "1",
      icon: <FiEdit />,
      label: "Editar",
    }
  ]

  const menuDelete = [
    {
      key: "2",
      icon: <FiTrash2 />,
      label: "Eliminar",
    }
  ]



  const menu = (item) => (
    <div>

      {!hasPermission(actions.UsuariosEditar) && (
        <Menu items={menuSearch} onClick={() => onClickEdit(item)} />
      )}

      {hasPermission(actions.UsuariosEditar) && (
        <Menu items={menuEdit} onClick={() => onClickEdit(item)} />
      )}

      {hasPermission(actions.UsuariosEliminar) && (
        <Menu items={menuDelete} onClick={() => onClickDelete(item)} />
      )}

    </div>
  );

  const onClickAdd = () => {
    navigate("/usuarios/nuevo");
  };

  const onClickEdit = (item) => {
    navigate(`/usuarios/${item.id}`);
  };

  const onClickDelete = async (item) => {
    const confirmed = await confirm(
      "Eliminar usuario",
      `¿Esta seguro que desea eliminar al usuario ${item.nombre}?`
    );
    if (!confirmed) {
      return;
    }

    const response = await http.delete(`${BASEURL}/User/usuarios/${item.id}`);
    if (response) {
      await modalSuccess(
        "Usuario eliminado",
        "El usuario fue eliminado exitosamente"
      );
      navigate(0);
    }
  };

  const buttons = [
    {
      title: "Agregar Usuario",
      text: <FiPlus />,
      type: "primary",
      onClick: onClickAdd,
      visible: hasPermission(actions.UsuariosCrear),
    },
  ];

  return (
    <TableContextProvider>
      <Card>
        <Header
          title={title}
          icon={icon}
          breadcrumb={breadcrumb}
          showFilters
          buttons={buttons}
        />
        <Filters fields={filters} />
        <Table
          id="table-usuarios"
          columns={columns}
          menu={menu}
          url="/User/usuarios"
          orderBy="nombre"
          orderDirection="ascending"
        />
      </Card>
    </TableContextProvider>
  );
};

export default UsuariosListPage;
